import gql from "graphql-tag";

export const UPDATE_USER_QUERY = gql`
  mutation UpsertUserMutation($id: ID, $data: UserUpdateInput!) {
    upsertUser(data: $data, where: { id: $id }) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/UpdateUser/queries.ts